import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';

import { Button, ButtonType } from '../Button';

export interface PrivateNote {
  comment?: string;
  updated?: string;
}

export interface PrivateNoteSectionProps {
  note?: PrivateNote;
  onEdit: () => void;
  emptyLabel?: string;
  editLabel?: string;
  locale?: string;
}

export const PrivateNoteSection = ({
  note,
  onEdit,
  emptyLabel = 'Save a private note to self',
  editLabel = 'Edit',
  locale = 'en-US',
}: PrivateNoteSectionProps): JSX.Element => (
  <>
    {note?.comment && (
      <div className='text-sm italic mb-1'>{note.comment}</div>
    )}
    <div className='mb-3 text-sm flex items-center gap-1 flex-wrap'>
      <FontAwesomeIcon icon={faLock} className='text-neutral-600' aria-hidden='true' />
      {note ? (
        <>
          {note.updated && (
            <span className='text-neutral-500'>
              {new Date(note.updated).toLocaleDateString(locale)}
            </span>
          )}
          <Button
            buttonType={ButtonType.tertiary}
            className='!p-0 underline'
            onClick={onEdit}
          >
            {editLabel}
          </Button>
        </>
      ) : (
        <Button
          buttonType={ButtonType.tertiary}
          className='!p-0 underline'
          onClick={onEdit}
        >
          {emptyLabel}
        </Button>
      )}
    </div>
  </>
);
